import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { HatAlert } from '~/components/shared'
import { fetchSystemWarnings } from '~/services'
import { useLoggedInUser } from '~/context'

export const SystemWarnings = (): JSX.Element => {
  const { user } = useLoggedInUser()
  const { data } = useQuery(['systemWarnings'], fetchSystemWarnings, { enabled: !!user })

  return <HatAlert icon="MiQuestionCircle" description={data?.[0]?.content} show={data && data?.length > 0} />
}
